<template>
  <b-modal id="group-quote-modal"
           hide-header-close
           size="lg" centered @show="getRepInfo">
    <!-- close-btn -->
    <b-button variant="close-btn" btn-container-quote @click="closeGroupQuoteModal">
      <i class="fas fa-times"></i>
    </b-button>

    <!-- modal header -->
    <div class="quote-modal text-center pb-1">
      <h5><strong>Send New Group Quote</strong></h5>
    </div>

    <!-- select options -->
    <div class="select-new-existing text-center pt-0" v-if="!isFormVisible">
      <div class="text-center">
        <div class="d-flex justify-content-center">
          <div>Group quote for a</div>
          <div class="new-group-option ms-2" @click="onNewGroupSelect">New group</div>
        </div>
        <div class="mb-2 mt-2">OR,</div>
        <multiselect name="group" placeholder="Select Existing Groups"
          :options="existingGroups.map(item => ({ text: item.gname, value: item.gid }))" :custom-label="(opt) => opt.text"
          :options-limit="100" :internal-search="false" :local-search="false" @search-change="searchHandler"
          @select="onExistingGroupSelect" />

      </div>
    </div>

    <!-- back button -->
    <!-- <i class="fa-solid fa-arrow-left" v-if="isFormVisible" @click="onBackClick"></i> -->

    <!-- modal body -->
    <div v-if="isFormVisible" id="group-quote">
      <!-- first row -->
      <ValidationObserver mode="lazy" ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitGroupQuote)">
          <div class="row mt-2">
            <!-- group name -->
            <input-text labelName="Group Name" labelFor="groupName" inputName="groupName"
              formGroupClass="border-0 col-xxl-4 col-lg-4 col-md-6 mb-3" :vmodel.sync="groupName"
              :rules="{ required: true }" :readonly="isAnExistingGroup"/>

            <!-- group address -->
            <input-text labelName="Group Address" labelFor="groupAddress" inputName="groupAddress"
              formGroupClass="border-0 col-xxl-4 col-lg-4 col-md-6 mb-3" :vmodel.sync="groupAddress"
              :rules="{ required: true }" :readonly="isAnExistingGroup"/>

            <input-date-picker
              :vmodel.sync="requestedStartDate"
              :rules="{ required: true }"
              inputName="requstedDate"
              label="Requested Start Date"
              date-format="MM/DD/YYYY"
              form-group-class="col-xxl-4 col-lg-4 col-md-6 mb-3"
              inputClass="form-control"
              disableDateType="disable-upto-yesterday"
              placeholder="Request Start Date"
              :isDisabled="isAnExistingGroup"
            />

            <!-- group industry -->
            <input-select labelName="Group Industry" labelFor="groupIndustry" defaultOption="Select Industry"
              inputName="groupIndustry" formGroupClass="border-0 col-xxl-4 col-lg-4 col-md-6 mb-3"
              :vmodel.sync="groupIndustry" :rules="{ required: true }" :options="groupIndustryList" :disabled="isAnExistingGroup"/>

            <!-- group contact name -->
            <input-text labelName="Group Contact Name" labelFor="contactName" inputName="contactName"
              formGroupClass="border-0 col-xxl-4 col-lg-4 col-md-6 mb-3" :vmodel.sync="contactName"
              :rules="{ required: true }" :readonly="isAnExistingGroup"/>

            <!-- group contact email -->
            <input-text labelName="Group Contact Email" labelFor="contactEmail" inputName="contactEmail"
              formGroupClass="border-0 col-xxl-4 col-lg-4 col-md-6 mb-3" :vmodel.sync="contactEmail"
              :rules="{ required: true, email: true }" :readonly="isAnExistingGroup"/>

            <!-- group contact phone number -->
            <input-text labelName="Group Contact Phone Number" labelFor="contactNumber" inputName="contactNumber"
              formGroupClass="border-0 col-xxl-4 col-lg-4 col-md-6 mb-3" :vmodel.sync="contactNumber"
              :rules="{ required: true, clearoutPhone: true }" :maxLength="10" :readonly="isAnExistingGroup"/>

            <!-- enrollment platform -->
            <input-select labelName="Enrollment Platform" labelFor="enrollmentPlatform" inputName="enrollmentPlatform"
              defaultOption="Select Enrollment Platform" formGroupClass="border-0 col-xxl-4 col-lg-4 col-md-6 mb-3"
              :vmodel.sync="enrollmentPlatform" :rules="{ required: true }" :options="enrollmentPlatformList" :disabled="isAnExistingGroup"/>
          </div>
          
            <!-- submit form btn -->
          <div class="row mt-2">
            <div class="d-flex col-12 gap-3 quote-action-btns">
              <button type="submit" @click="onBackClick" class="btn secondary-btn mt-0">Back</button>
              <button type="submit" class="new-quote-btn mt-0">Submit</button>
            </div>
          </div>

        </form>
      </ValidationObserver>
    </div>
  </b-modal>
</template>

<script>
import Api from "@/resource/Api";
import { ValidationObserver } from "vee-validate";
import InputDatePicker from "../../../../components/form/InputDatePicker.vue";

export default {
  name: "GroupQuoteSubmission",
  components: {
    ValidationObserver,
    InputDatePicker,
  },
  data() {
    return {
      groupName: "",
      groupAddress: "",
      requestedStartDate: "",
      groupIndustry: "",
      contactName: "",
      contactEmail: "",
      contactNumber: "",
      submitterName: "",
      submitterEmail: "",
      submitterPhone: "",
      enrollmentPlatform: "",
      enrollmentPlatformList: [],
      groupIndustryList: [],
      isFormVisible: false,
      existingGroups: [],
      repId: null,
      isAnExistingGroup: false,
      gagent_code: "",
      groupId: null,
    };
  },
  
  methods: {
    onSelectGroupIndustry(selectedIndustry) {
      this.groupIndustry = selectedIndustry;
    },

    onSelectPlatform(platform) {
      this.enrollmentPlatform = platform;
    },

    //fetch and populate the enrollment platform list
    getEnrollmentPlatformList() {
      const loader = this.$loading.show();
      Api.get("v2/quote/platform")
        .then((response) => {
          const platformResponse = response.data;
          const platformList = platformResponse.data;
          if (platformList) {
            this.enrollmentPlatformList = platformList.map((platform) => {
              return {
                text: platform.platform_website,
                value: platform.platform_website,
              };
            });
          }
        })
        .finally(() => loader.hide());
    },
    //fetch and populate the group industry list
    getGroupIndustryList() {
      const loader = this.$loading.show();
      Api.get("v2/get-employer-industry")
        .then((response) => {
          const industryResponse = response.data;
          const industryList = industryResponse.data;
          if (industryList) {
            this.groupIndustryList = industryList.map((industry) => {
              return {
                text: industry.title,
                value: industry.value,
              };
            });
          }
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => loader.hide());
    },
    getRepInfo() {
      const loader = this.$loading.show();
      Api.get("v2/get-agent-info")
        .then((response) => {
          const repData = response.data;
          const rep = repData.data.personal;

          this.submitterName = rep.name;
          this.submitterEmail = rep.email;
          this.submitterPhone = rep.telephone;
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => loader.hide());
    },

    onExistingGroupSelect(e) {

      console.log("from multiselect", e);

      this.isFormActive = true;
      this.getRepInfo();
      this.isAnExistingGroup = true;

      const id = e.value || "";
      this.groupId = id;
      const currentGroup =
        this.existingGroups.filter((item) => item.gid == id)[0] || [];
      this.groupName = currentGroup.gname;
      this.groupAddress = currentGroup.gaddress1;
      this.requestedStartDate = this.handleDateFormat(currentGroup.idilus_dsd);
      this.groupIndustry = currentGroup.emp_industry;
      this.enrollmentPlatform = currentGroup.platform_website;
      this.contactName = currentGroup.group_contact_full_name;
      this.contactEmail = currentGroup.gemail2;
      this.contactNumber = currentGroup.gphone;
      this.gagent_code = currentGroup.gagent_code;

      this.showForm();
    },

    onNewGroupSelect() {
      this.isFormActive = true;
      this.clearInputFields();
      this.getRepInfo();
      this.showForm();
      this.isAnExistingGroup = false;
    },

    clearInputFields() {
      this.groupName = "";
      this.groupAddress = "";
      this.requestedStartDate = "";
      this.groupIndustry = "";
      this.contactName = "";
      this.contactEmail = "";
      this.contactNumber = "";
      this.submitterName = "";
      this.submitterEmail = "";
      this.submitterPhone = "";
      this.enrollmentPlatform = "";
    },

    async submitGroupQuote() {
      let url;
      let payload = {
        group_name: this.groupName,
        group_address: this.groupAddress,
        group_requested_start_date: this.requestedStartDate,
        group_industry: this.groupIndustry,
        group_contact_name: this.contactName,
        group_contact_email: this.contactEmail,
        group_contact_phone: this.contactNumber,
        platform_name: this.enrollmentPlatform,
      };

      if (this.isAnExistingGroup) {
        payload = {
          group_id:this.groupId,
          group_name: this.groupName,
          group_address: this.groupAddress,
          group_requested_start_date: this.requestedStartDate,
          group_industry: this.groupIndustry,
          group_contact_name: this.contactName,
          group_contact_email: this.contactEmail,
          group_contact_phone: this.contactNumber,
          platform_name: this.enrollmentPlatform,
        };

        url = `v2/quote/submit-existing-group?gagent_code=${this.gagent_code}`;
      } else {
        payload = {
          group_name: this.groupName,
          group_address: this.groupAddress,
          group_requested_start_date: this.requestedStartDate,
          group_industry: this.groupIndustry,
          group_contact_name: this.contactName,
          group_contact_email: this.contactEmail,
          group_contact_phone: this.contactNumber,
          platform_name: this.enrollmentPlatform,
          submitter_name: this.submitterName,
          submitter_phone: this.submitterPhone,
          submitter_email: this.submitterEmail,
          is_personalized_quote: 1,
        };

        url = "v2/quote/store-groupquote";
      }

      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      } else {
        let loader = this.$loading.show();
        Api.post(url, payload)
          .then((response) => {
            this.$notify(response.data.message);
            this.$bvModal.hide("group-quote-modal");
            this.$store.dispatch("fetchGroupQuotes");
            this.$store.commit("setActiveList", "group");
            this.clearInputFields();

            if (response.status == 200) {
              this.gagent_code = null;
              this.isFormVisible = false;
            }
            // this.$emit("renderViewList", {});
          })
          .catch((e) => {
            this.gagent_code = null;
            this.$notify(e.response.data.message, "error");
          })
          .finally(() => {
            loader.hide();
          });

        this.$refs.observer.reset();
        this.getExistingGroups();
      }
    },
    getExistingGroups(query) {
      let url;
      let loader = this.$loading.show();
      if(!query) url="v2/quote/existing-groups"
      else url = `v2/quote/existing-groups?group_name=${query}`

      Api.get(url)
        .then((response) => {
          const responseData = response.data;

          this.existingGroups = responseData.data;
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => loader.hide());
    },

    showForm() {
      this.isFormVisible = true;
    },

    closeGroupQuoteModal() {
      this.$bvModal.hide("group-quote-modal");
      this.getExistingGroups();
      this.$refs.observer.reset();
      this.isFormVisible = false;
    },

    onBackClick() {
      this.isFormVisible = false;
      this.clearInputFields();
      this.isAnExistingGroup = false;
      this.getExistingGroups();
    },
    //get formatted date
    handleDateFormat(date) {
      const time = new Date(date);

      const month = String(time.getMonth() + 1).padStart(2, "0");
      const day = String(time.getDate()).padStart(2, "0");
      const year = time.getFullYear();

      return `${month}/${day}/${year}`;
    },

    searchHandler(query) {
      if (query.length > 2) {
        this.getExistingGroups(query);
      }
    }
  },
  created() {
    this.getEnrollmentPlatformList();
    this.getGroupIndustryList();
    this.getExistingGroups();
  },
  update() {
    this.getGroupQuote();
  },
};
</script>

<style>
.new-group-option {
  color: #0a75bb;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

#group-quote-modal{
  /* min-height: fit-content; */
}

.select-new-existing {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.75rem 0;
}

.select-new-existing p {
  font-size: 1.15rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.select-new-existing select {
  padding: 9px 8px;
  border: 1px solid #ced4da;
  background-color: #ffffff;
  border-radius: 5px;
  cursor: pointer !important;
}

.mx-datepicker {
  width: 100% !important;
}

.fa-arrow-left {
  font-size: 1.15rem;
  cursor: pointer;
}

.quote-action-btns {
  justify-content: flex-end;
}
.quote-action-btns .new-quote-btn {
  min-width: 150px;
}

.quote-btn-top {
  max-width: 250px;
}

@media (max-width:991px) {
  .quote-btn-top {
    margin-top: 0rem;
    display: flex;
    justify-content: end;
  }

  .quote-action-btns .new-quote-btn {
    max-width: 200px;
  }
}
@media (max-width:576px) {
  .quote-action-btns {
    flex-direction: column;
  }
  .quote-action-btns .new-quote-btn {
    max-width: none;
  }
}
</style>